import React from "react";
import Widget from "../../../../shared/components/features/widget/Widget";
import { useSelector } from "react-redux";
import pathRouts from "../../../../shared/enums/pathRoute";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import ProfessionalDevelopmentImg from "../../../../assests/plusLearning/ProfessionalDevelopmentImg.svg";
import classes from "./ProfessionalDevelopmentWidget.module.css";

const ProfessionalDevelopmentWidget = () => {
    const { texts } = useSelector(state => state.translate);

    return (
        <Widget
            color="#F1799A"
            mainLink={`/${pathRouts.PROFFESSIONALDEVELOPMENT}`}
            title={texts.ProfessionalDevelopment}
            icon={iconsList.professionalDevelopment}
            className={classes.PlusLearningWidget}
        >
            <div className={classes.PlusLearningContent}>
                <img
                    src={ProfessionalDevelopmentImg}
                    alt={texts.plusLearning}
                    className={classes.PlusLearningImg}
                />
                <div className={classes.PlusLearningText}>
                    {texts.ProfessionalDevelopmentTextWidget}
                </div>
            </div>
        </Widget>
    );
};

export default ProfessionalDevelopmentWidget;